import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "sequence-labeling" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = { class: "bg-white rounded p-10" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<h3 class=\"mb-5\"><span class=\"card-label fw-bolder fs-3 mb-1\"> Berita </span></h3><div class=\"border rounded mb-5 py-2 px-2\"> Keterangan Warna: <div class=\"d-flex justify-content-between gap-10\"><div class=\"d-flex align-items-center\"> CUE : <div style=\"height:1.2rem;width:5rem;\" class=\"ms-2 rounded CUE\"></div></div><div><div class=\"d-flex align-items-center\"> SOURCE : <div style=\"height:1.2rem;width:5rem;\" class=\"ms-2 rounded SOURCE\"></div></div></div><div><div class=\"d-flex align-items-center\"> CONTENT : <div style=\"height:1.2rem;width:5rem;\" class=\"ms-2 rounded CONTENT\"></div></div></div></div></div>", 2)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "CUE" }, "CUE", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "SOURCE" }, "SOURCE", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "CONTENT" }, "CONTENT", -1)
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title mb-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, " Kata Terpilih ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" CUE ")
const _hoisted_18 = { class: "d-flex flex-wrap align-center" }
const _hoisted_19 = {
  key: 0,
  class: "border border-warning d-flex align-center rounded p-1 me-2 mb-1"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x text-danger fs-5" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" SOURCE ")
const _hoisted_25 = { class: "d-flex flex-wrap align-center" }
const _hoisted_26 = {
  key: 0,
  class: "border border-warning d-flex align-center rounded p-1 me-2 mb-1"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x text-danger fs-5" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" CONTENT ")
const _hoisted_32 = { class: "d-flex flex-wrap align-center" }
const _hoisted_33 = {
  key: 0,
  class: "border border-warning d-flex align-center rounded p-1 me-2 mb-1"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x text-danger fs-5" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", {
              innerHTML: _ctx.hightlight_word,
              onMouseup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseUp && _ctx.handleMouseUp(...args))),
              style: {"max-height":"50vh","overflow":"auto"}
            }, null, 40, _hoisted_8),
            _withDirectives(_createElementVNode("select", {
              id: "label-selector",
              class: "form-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.label_selected) = $event)),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSelectChange())),
              style: _normalizeStyle([{"width":"200px"}, { display: _ctx.opacity == 0 ? 'none' : '' }])
            }, _hoisted_12, 36), [
              [_vModelSelect, _ctx.label_selected]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", null, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selection_data, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                    (item[2] == 'CUE')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                          _createTextVNode(_toDisplayString(_ctx.word.substring(item[0], item[1])) + " - " + _toDisplayString(item) + " ", 1),
                          _createElementVNode("span", {
                            onClick: ($event: any) => (_ctx.deleteElement(index)),
                            class: "text-danger",
                            style: {"cursor":"pointer"}
                          }, _hoisted_22, 8, _hoisted_20)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _hoisted_23
            ]),
            _createElementVNode("div", null, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selection_data, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                    (item[2] == 'SOURCE')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                          _createTextVNode(_toDisplayString(_ctx.word.substring(item[0], item[1])) + " - " + _toDisplayString(item) + " ", 1),
                          _createElementVNode("span", {
                            onClick: ($event: any) => (_ctx.deleteElement(index)),
                            class: "text-danger",
                            style: {"cursor":"pointer"}
                          }, _hoisted_29, 8, _hoisted_27)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _hoisted_30
            ]),
            _createElementVNode("div", null, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selection_data, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                    (item[2] == 'CONTENT')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                          _createTextVNode(_toDisplayString(_ctx.word.substring(item[0], item[1])) + " - " + _toDisplayString(item) + " ", 1),
                          _createElementVNode("span", {
                            onClick: ($event: any) => (_ctx.deleteElement(index)),
                            class: "text-danger",
                            style: {"cursor":"pointer"}
                          }, _hoisted_36, 8, _hoisted_34)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _hoisted_37
            ])
          ])
        ])
      ])
    ])
  ]))
}